export const tags = [
  {
    id: '1',
    name: 'Production',
    count: 245,
    percentage: 35,
    color: 'text-red-500'
  },
  {
    id: '2',
    name: 'Development',
    count: 189,
    percentage: 27,
    color: 'text-blue-500'
  },
  {
    id: '3',
    name: 'Staging',
    count: 156,
    percentage: 22,
    color: 'text-yellow-500'
  },
  {
    id: '4',
    name: 'Testing',
    count: 112,
    percentage: 16,
    color: 'text-emerald-500'
  }
];